import Home from '../components/Home'
import View from '../components/View'

let routes = {
    path: '/',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/view/:id?',
            name: 'View',
            component: View
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/home.js